import api from './api';

/**
 * Service pour gérer les payouts des propriétaires
 */
class PayoutService {
  /**
   * Récupère le payout de compensation de dommages pour une réservation
   * @param {string} reservationId - ID de la réservation
   * @returns {Promise<Object>} Payout de compensation ou null
   */
  async getDamageCompensationByReservation(reservationId) {
    try {
      const response = await api.get(
        `/payouts/damage-compensation/reservation/${reservationId}`
      );

      return response?.data?.data ?? null;
    } catch (error) {
      // Si c'est une erreur 404, retourner null (pas de payout trouvé)
      if (error.response?.status === 404) {
        return null;
      }
      // Pour les autres erreurs, les propager
      throw error;
    }
  }
}

export default new PayoutService();
